import { render, staticRenderFns } from "./CarrierManifestsTable.vue?vue&type=template&id=754b903f&scoped=true&"
import script from "./CarrierManifestsTable.vue?vue&type=script&lang=js&"
export * from "./CarrierManifestsTable.vue?vue&type=script&lang=js&"
import style0 from "./CarrierManifestsTable.vue?vue&type=style&index=0&id=754b903f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b903f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754b903f')) {
      api.createRecord('754b903f', component.options)
    } else {
      api.reload('754b903f', component.options)
    }
    module.hot.accept("./CarrierManifestsTable.vue?vue&type=template&id=754b903f&scoped=true&", function () {
      api.rerender('754b903f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/CarrierManifestsTable.vue"
export default component.exports